export default "__VITE_ASSET__BMOuN_pH__"